import "./index.scss";
import RouterMain from "./pages/router/RouterMain";
import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
import { CookieStorage } from "aws-amplify/utils";
import { useEffect } from "react";

cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage());
Amplify.configure(awsExports);
function App() {
  return (
    <>
      <RouterMain />
    </>
  );
}

export default App;
